export default __webpack_public_path__ + "assets/c59820ea57e4ad074b0816b9fd10f9be.svg";